exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".header-component{position:fixed;top:0;width:100%;z-index:1000}@media only screen and (min-width:600px){.header-component{width:598px}}.header-component .title{height:44px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;display:inline-block;max-width:200px;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/styles/Header.scss
// module id = 640
// module chunks = 0